import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SEApplicationView from "../../components/services/secondaryEducation/SEApplicationView";
import { baseEndpointPaths, getApplicationById } from "../../../services/serviceCalls";
import { useSearchParams } from "react-router-dom";

const SERecognitionViewPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.view`)}>
      <SEApplicationView serviceFn={getApplicationById(baseEndpointPaths.seRecognition, id)} />
    </PageWrapper>
  );
};

export default SERecognitionViewPage;
